import React, { useCallback, useEffect, useState } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { updateTaskSimple } from '../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import { taskSimpleSelectors } from '../../../../../../app/resource/task-simple/task-simple.selectors';
import { useSelectWithParams } from '../../../../../../utils/selector.utils';

import { IStatusProps } from './types';
import moment from 'moment';

export const Status: FunctionComponent<IStatusProps> = ({ taskId }) => {
  const task = useSelectWithParams(taskSimpleSelectors.selectResourceById, taskId);
  const dispatch = useDispatch();

  const [disabled, setDisabled] = useState(task?.status === '1' ? false : true);

  useEffect(() => {
    if (task) {
      task.status === '1' ? setDisabled(false) : setDisabled(true);
    }
  }, [task]);
  const handleChange = useCallback(() => {
    if (task) {
      dispatch(
        updateTaskSimple(task.id, {
          status: disabled ? '1' : '0',
        }),
      );
    }
  }, [disabled, dispatch, task]);
  if (!task) {
    return null;
  }
  return (
    task && (
      <div className="mr-2">
        <div className={`badge ${disabled ? 'white-bg' : 'lightGreen-bg'}`} style={{ minHeight: '25px' }}>
          <div className="remember-checkbox flex aic jcl">
            <input
              type="checkbox"
              id="doneCheckboxx"
              name="doneCheckboxx"
              onChange={handleChange}
              checked={!disabled}
              disabled={task.isLocked}
            />
            <label htmlFor="doneCheckboxx" style={{ color: `${disabled ? 'darkGray' : 'green'}` }}>
              Done{' '}
              {task && task.completedAt && moment(task.completedAt).isValid()
                ? moment(task.completedAt).format('MM/DD/YYYY')
                : ''}
            </label>
          </div>
        </div>
      </div>
    )
  );
};
